<template lang="pug">
k-page.login
  #bg-image-wrapper
    transition( name='fade' )
      img#bg-image( :src='img' @load='showImg' v-show='show' )
  .featured-outer.small

  k-main( :title='title' )
    //- login-form( :redirect='then' )
    .message( v-if='then' )
      | Please log in or sign up to access that page/content.
</template>

<script lang="js">
import { mapActions } from 'vuex'
import he from 'he'
import _wpapix from '@/lib/wpapix'
import KPage from '@/blocks/k-page'
import KMain from '@/blocks/k-main'
import LoginForm from '@/components/login-form'

export default {
  name: 'LoginPage',
  mixins: [],
  components: { LoginForm, KPage, KMain },
  props: {
    then: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      img: '',
      title: '',
      show: false
    }
  },
  created() {},
  mounted() {
    document.title = he.decode( this.$store.state.site.title )
    _wpapix.then( wpapix => {
      var path = new wpapix.Path({ path: 'login' })
      path.fetch().done(( rpost ) => {
        console.log( 'got login page', rpost )
        this.title = rpost.title.rendered
        this.img = rpost.background_image || ''
        this.$nextTick(() => {
          this.openModal({ name: 'm-auth', data: { redirect: `/${ this.then }` }})
        })
      })
    })
  },
  methods: {
    ...mapActions([ 'openModal' ]),
    showImg() {
      this.show = true
    }
  },
  computed: {}
}
</script>

<style lang="scss">
.login {
  .k-main {
    display: flex;
    flex-direction: column;
    justify-content: center;;
  }
}
</style>
